module.exports = __webpack_public_path__ + "static/media/sub_competency_inactive.51c06228.svg";